export const colors = {
  brand: {
    100: "#fcfdfd",
    200: "#e5eef2",
    300: "#e1eef3",
    400: "#ddedf4",
    500: "#c7e6f3",
    600: "#add9eb",
    700: "#93cee5",
    800: "#54b7de",
    900: "#1c9bcd",
    1000: "#0474a1",
  },
  black: {
    100: "rgba(12, 12, 13, 0.0500)",
    200: "rgba(12, 12, 13, 0.1000)",
    300: "rgba(12, 12, 13, 0.2000)",
    400: "rgba(12, 12, 13, 0.4000)",
    500: "rgba(12, 12, 13, 0.7000)",
    600: "rgba(12, 12, 13, 0.8000)",
    700: "rgba(12, 12, 13, 0.8500)",
    800: "rgba(12, 12, 13, 0.9000)",
    900: "rgba(12, 12, 13, 0.9500)",
    1000: "#0c0c0d",
  },
  white: {
    1000: "#FFFFFF",
  },
  gray: {
    100: "#f5f5f5",
    200: "#e6e6e6",
    300: "#d9d9d9",
    400: "#b3b3b3",
    500: "#757575",
    600: "#444444",
    700: "#383838",
    800: "#2c2c2c",
    900: "#1e1e1e",
    1000: "#111111",
  },
  red: {
    100: "#fee9e7",
    200: "#fdd3d0",
    300: "#fcb3ad",
    400: "#f4776a",
    500: "#ec221f",
    600: "#c00f0c",
    700: "#900b09",
    800: "#690807",
    900: "#4d0b0a",
    1000: "#300603",
  },
  slate: {
    100: "#f3f3f3",
    200: "#e3e3e3",
    300: "#cdcdcd",
    400: "#b2b2b2",
    500: "#949494",
    600: "#767676",
    700: "#5a5a5a",
    800: "#434343",
    900: "#303030",
    1000: "#242424",
  },
};
